import { css } from '@emotion/react'

const svgStyles = css`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
`

export const DashedBorderSvg = ({
  strokeWidth = 2,
  strokeDasharray = '6,6',
  borderRadius = '8',
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" css={svgStyles} className="dashed-border-svg">
      <rect
        x="0"
        y="0"
        width="100%"
        height="100%"
        stroke="none"
        fill="none"
        strokeWidth={strokeWidth}
        strokeDasharray={strokeDasharray}
        rx={borderRadius}
        ry={borderRadius}
      />
    </svg>
  )
}
